import { render, staticRenderFns } from "./PerformResetPasswordSuccess.vue?vue&type=template&id=17fe7262&"
import script from "./PerformResetPasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./PerformResetPasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PerformResetPasswordSuccess.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports